import { type FilterCountDto } from "~/types/api";

/**
 * Each { filter, count } becomes a [key, value] pair: ["chilled", 22], ["frozen", 5].
 * Then the Map changes it to: { "chilled" => 22, "frozen" => 5 }
 */
export const countByFilter = (counts?: FilterCountDto[]) =>
  new Map(counts?.map((c) => [c.filter.toLowerCase(), c.count]));
